import React, { useState, useEffect } from "react";
import ApiUtils from "../../../utils/api_utils";
import { connect } from "react-redux";
import { Row, Col, ListGroup } from "react-bootstrap";
import * as Assets from "../../../utils/svg_assets";
import { toast } from "react-toastify";
import "./style.scss";
import {
  ConfirmationDialog,
  InformationDialog,
} from "../../../components/DialogCollection";
const UsersBoard = (p) => {
  const { submitUnblock, getList } = p;
  const [IsOpen, setIsOpen] = useState();
  const [IsSuccess, setIsSuccess] = useState();
  const [UserUnblock, setUserUnblock] = useState();
  const [IdUserUnblock, setIdUserUnblock] = useState();
  const [filter, setFilter] = useState("");
  const [dataBlock, setdataBlock] = useState();
  const [filterdataUsers, setfilterdataUsers] = useState();
  const processUnblock = async () => {
    await submitUnblock(IdUserUnblock).then(function (result) {
      if (result.status === 200) {
        setIsSuccess(true);
      } else {
        toast.error("Kesalahan pada sistem", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      }
    });
  };

  const processFilter = (filter) => {
    var Data = dataBlock.filter((user) =>
      user.name.toLowerCase().includes(filter.toLowerCase())
    );
    setfilterdataUsers(Data);
  };
  const getDataBlock = async () => {
    const { status, data } = await getList();
    if (status == 200) {
      setdataBlock(data);
      setfilterdataUsers(data);
    }
  };
  useEffect(() => {
    getDataBlock();
  }, []);
  return (
    <div className="users-leaderboard-wrapper">
      {IsOpen ? (
        <ConfirmationDialog
          title="Unblock"
          message={"Do you want to Unblock " + UserUnblock + " ?"}
          confirmLabel="Yes"
          cancelLabel="No"
          isCustomBtn
          style={{ width: "300px" }}
          show={true}
          onCancel={() => {
            setIsOpen(false);
          }}
          onConfrim={() => {
            processUnblock();
          }}
        />
      ) : (
        ""
      )}
      {IsSuccess ? (
        <InformationDialog
          title="Successful"
          style={{ width: "300px" }}
          message={"You can see all post/comment from " + UserUnblock}
          closeLabel="Done"
          show={IsSuccess}
          onHide={() => {
            setIsSuccess(false);
            setIsOpen(false);
            getDataBlock();
          }}
        />
      ) : (
        ""
      )}
      <div class="center-block">
        <input
          class="form-control search-block"
          type="text"
          placeholder="Search"
          value={filter}
          onFocus={(e) => {
            setFilter(e.target.value);
            processFilter(e.target.value);
          }}
          onChange={(e) => {
            setFilter(e.target.value);
            processFilter(e.target.value);
          }}
        />
      </div>
      {filterdataUsers &&
        filterdataUsers
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((a, index) => (
            <div>
              <ListGroup key={index}>
                <ListGroup.Item>
                  <Row>
                    <Col xs={3} sm={3} md={3}>
                      <img
                        src={
                          a.img_thumbnail
                            ? ApiUtils.validateImgUrl({
                                url: a.img_thumbnail,
                              })
                            : Assets.iconProfile
                        }
                        className="leaderboard-img"
                        alt="leaderboard_image"
                      />
                    </Col>
                    <Col xs={5} sm={5} md={5}>
                      <div className="leaderboard-fullname">{a.name}</div>
                      <div className="leaderboard-tier">{a.department}</div>
                    </Col>
                    <Col xs={3} sm={3} md={3}>
                      <button
                        class="border-0 btn btn-danger btn-sm"
                        onClick={() => {
                          setIsOpen(true);
                          setUserUnblock(a.name);
                          setIdUserUnblock(a.id);
                        }}
                      >
                        Unblock
                      </button>
                    </Col>
                  </Row>
                </ListGroup.Item>
              </ListGroup>
            </div>
          ))}
    </div>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  submitUnblock: dispatch.BlockSM.submitUnblock,
  getList: dispatch.BlockSM.getList,
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersBoard);
